import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import { connect } from 'unistore/full/react';
import actions from './actions';
import ContextMenu from './ContextMenu';
import CreateNewPlaylist from './CreateNewPlaylist';
import Tabs from './FigmaComponents/Tabs';
import HubPage from './HubPage';
import MiniPlayer from './MiniPlayer';
import Notification from './Notification';
import NowPlayingView from './NowPlayingView';
import Playlist from './Playlist';
import Search from './Search';
import YourLibrary from './YourLibrary';
import Settings from './Settings';
import PlaybackSettings from './PlaybackSettings';
import SeedPicker from './SeedPicker';
import CreateNewTypePicker from './CreateNewTypePicker';
import PlaylistTagRadio from './PlaylistTagRadio';

class Main extends React.Component {
  componentDidMount() {
    this.props.setupHarmony();
    this.props.setupUser();
  }

  handleChange = (event, newActiveTabIndex) =>
    this.props.setActiveTabIndex(newActiveTabIndex);

  render() {
    const {
      contextMenuUri,
      contextMenuContextUri,
      isContextMenuOpen,
    } = this.props;
    return (
      <>
        <ContextMenu
          uri={contextMenuUri}
          contextUri={contextMenuContextUri}
          isOpen={isContextMenuOpen}
        />
        <NowPlayingView />
        <Switch>
          <Route path="/search/:section?/:searchString" component={Search} />
          <Route path="/search/:searchString?" component={Search} />
          {/* <Route path="/matchmaker/:stationId" component={Swiper} /> */}
          <Route path="/playlist/:id/:section?" component={Playlist} />
          <Route path="/dynamic-playlist/:id/:section?" component={Playlist} />
          <Route
            path="/station/:type/:id/:genre?"
            component={PlaylistTagRadio}
          />
          <Route path="/settings/playback" component={PlaybackSettings} />
          <Route path="/settings" component={Settings} />
          <Route
            path="/user/:user/playlist/:id/:section?"
            component={Playlist}
          />
          <Route path="/:hub(genre)/:page" component={HubPage} />
          <Route
            path="/home"
            render={(routeProps) => (
              <HubPage
                {...routeProps}
                url="https://spclient.wg.spotify.com/vanilla/v1/views/hub2/desktop-home"
                rightAction={
                  <Link to="/settings">
                    <svg
                      width="72"
                      height="32"
                      viewBox="0 0 72 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M68.965 17.619C68.353 17.32 67.957 16.685 67.957 16.001C67.957 15.32 68.353 14.687 69.023 14.361C69.829 14.027 70.213 13.1 69.88 12.296L69.606 11.632C69.272 10.827 68.346 10.443 67.539 10.777L67.73 11.239L67.48 10.798C66.833 11.02 66.107 10.852 65.626 10.371C65.143 9.88799 64.973 9.15899 65.22 8.45299C65.381 8.06399 65.381 7.63599 65.22 7.24699C65.059 6.85799 64.756 6.55499 64.367 6.39399L63.704 6.11999C62.9 5.78699 61.977 6.16999 61.619 7.03499C61.32 7.64799 60.685 8.04299 60.002 8.04299C59.321 8.04299 58.688 7.64599 58.362 6.97699C58.027 6.16999 57.102 5.78699 56.296 6.11999L55.633 6.39499C54.828 6.72799 54.444 7.65599 54.799 8.52099C55.021 9.16599 54.854 9.89399 54.372 10.375C53.89 10.858 53.161 11.027 52.454 10.78C52.065 10.619 51.637 10.619 51.247 10.78C50.859 10.941 50.556 11.244 50.395 11.633L50.12 12.296C49.788 13.099 50.17 14.023 51.035 14.381C51.647 14.68 52.043 15.315 52.043 15.998C52.043 16.678 51.647 17.312 50.977 17.638C50.171 17.971 49.787 18.898 50.12 19.704L50.395 20.367C50.728 21.172 51.657 21.555 52.521 21.2C53.165 20.978 53.894 21.145 54.375 21.626C54.858 22.11 55.027 22.839 54.78 23.545C54.619 23.934 54.619 24.362 54.78 24.751C54.941 25.14 55.244 25.443 55.633 25.604L56.296 25.879C57.098 26.211 58.023 25.828 58.381 24.965C58.68 24.352 59.315 23.956 59.999 23.956C60.68 23.956 61.313 24.352 61.639 25.021C61.891 25.632 62.481 26 63.102 26C63.303 26 63.507 25.961 63.704 25.88L64.367 25.605C65.172 25.272 65.555 24.344 65.2 23.48C64.978 22.834 65.145 22.107 65.627 21.626C66.11 21.143 66.84 20.975 67.545 21.221C68.348 21.554 69.272 21.171 69.605 20.368L69.879 19.705C70.212 18.901 69.83 17.977 68.965 17.619ZM68.956 19.321L68.682 19.984C68.56 20.277 68.224 20.417 67.923 20.293L67.81 20.248C66.807 19.903 65.673 20.165 64.921 20.917C64.171 21.667 63.91 22.8 64.258 23.812L64.298 23.92C64.421 24.217 64.28 24.558 63.985 24.68L63.322 24.955C63.179 25.014 63.022 25.013 62.878 24.953C62.733 24.893 62.622 24.781 62.553 24.618L62.51 24.526C62.045 23.572 61.059 22.956 59.999 22.956C58.937 22.956 57.949 23.572 57.472 24.549L57.432 24.643C57.373 24.785 57.262 24.896 57.12 24.955C56.978 25.014 56.822 25.014 56.679 24.955L56.016 24.68C55.874 24.621 55.763 24.51 55.704 24.368C55.645 24.226 55.645 24.069 55.707 23.922L55.751 23.809C56.097 22.806 55.834 21.671 55.082 20.919C54.553 20.391 53.834 20.105 53.1 20.105C52.794 20.105 52.486 20.155 52.187 20.257L52.079 20.297C51.784 20.421 51.441 20.279 51.319 19.984L51.044 19.321C50.922 19.025 51.064 18.684 51.38 18.553L51.473 18.509C52.427 18.044 53.044 17.058 53.044 15.998C53.044 14.935 52.428 13.947 51.452 13.472L51.356 13.432C51.062 13.31 50.922 12.972 51.044 12.679L51.319 12.015C51.378 11.873 51.489 11.762 51.631 11.703C51.774 11.644 51.929 11.643 52.078 11.705L52.19 11.751C53.196 12.096 54.329 11.833 55.08 11.082C55.83 10.332 56.091 9.19899 55.743 8.18799L55.703 8.07999C55.579 7.78199 55.72 7.44099 56.016 7.31799L56.679 7.04399C56.822 6.98499 56.979 6.98599 57.123 7.04599C57.268 7.10599 57.379 7.21799 57.447 7.37899L57.49 7.47299C57.956 8.42699 58.942 9.04299 60.002 9.04299C61.065 9.04299 62.052 8.42699 62.527 7.45299L62.569 7.35699C62.628 7.21499 62.739 7.10399 62.881 7.04499C63.023 6.98599 63.179 6.98599 63.322 7.04499L63.985 7.31899C64.127 7.37799 64.238 7.48899 64.297 7.63099C64.356 7.77299 64.356 7.92999 64.295 8.07699L64.249 8.18999C63.904 9.19399 64.166 10.328 64.919 11.079C65.667 11.829 66.801 12.09 67.814 11.741L67.921 11.701C68.217 11.579 68.559 11.719 68.681 12.015L68.955 12.678C69.077 12.974 68.936 13.315 68.621 13.446L68.527 13.49C67.573 13.955 66.957 14.941 66.957 16.001C66.957 17.064 67.573 18.051 68.549 18.527L68.644 18.568C68.938 18.69 69.077 19.028 68.956 19.321ZM60 11.5C57.515 11.5 55.5 13.515 55.5 16C55.5 18.485 57.515 20.5 60 20.5C62.485 20.5 64.5 18.485 64.5 16C64.5 13.515 62.485 11.5 60 11.5ZM60 19.5C58.07 19.5 56.5 17.93 56.5 16C56.5 14.07 58.07 12.5 60 12.5C61.93 12.5 63.5 14.07 63.5 16C63.5 17.93 61.93 19.5 60 19.5Z"
                        fill="white"
                      />
                    </svg>
                  </Link>
                }
                noBack
              />
            )}
          />
          {/* <Route path="/" component={Onboarding} /> */}

          <Route path="/new/:type" component={SeedPicker} />
          <Route path="/new" component={CreateNewTypePicker} />
          <Route path="/edit/:type/:id/:section?" component={SeedPicker} />

          <Route path="/:section?">
            <YourLibrary />
          </Route>
        </Switch>
        <MiniPlayer />
        <Tabs />
        <Notification />
      </>
    );
  }
}

export default connect(
  [
    'activeTabIndex',
    'contextMenuUri',
    'contextMenuContextUri',
    'isContextMenuOpen',
  ],
  actions
)(Main);
